// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nw-0";
export var fileList = "_nw-2";
export var removeFileButton = "_nw-1";